/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AccountId,
  FilterUnitRegistrationRequest,
  HttpValidationProblemDetails,
  RegistrationCompositeId,
  SegmentationId
} from './data.schemas'




export const createCompositeWithFilterRegistration = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    filterUnitRegistrationRequest: FilterUnitRegistrationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RegistrationCompositeId>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/filter-units`,
      filterUnitRegistrationRequest,options
    );
  }



export const getCreateCompositeWithFilterRegistrationMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: FilterUnitRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: FilterUnitRegistrationRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompositeWithFilterRegistration>>, {segmentationId: SegmentationId;accountId: AccountId;data: FilterUnitRegistrationRequest}> = (props) => {
          const {segmentationId,accountId,data} = props ?? {};

          return  createCompositeWithFilterRegistration(segmentationId,accountId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompositeWithFilterRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof createCompositeWithFilterRegistration>>>
    export type CreateCompositeWithFilterRegistrationMutationBody = FilterUnitRegistrationRequest
    export type CreateCompositeWithFilterRegistrationMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useCreateCompositeWithFilterRegistration = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompositeWithFilterRegistration>>, TError,{segmentationId: SegmentationId;accountId: AccountId;data: FilterUnitRegistrationRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof createCompositeWithFilterRegistration>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;data: FilterUnitRegistrationRequest},
        TContext
      > => {

      const mutationOptions = getCreateCompositeWithFilterRegistrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    